import * as React from 'react';

import { ProductInventoryInfo, PartnerStockRow } from '../../models/Product';

import { formatMoney } from '../../components/shared/Utils';
import { GetQuantityResult } from '../../services/ProductInventoryService';

const getAvailableQuantity = (productQuantity: GetQuantityResult) => {
    return productQuantity && productQuantity.available ? productQuantity.available : 0;
}

const getOnOrderQuantity = (productQuantity: GetQuantityResult) => {
    return productQuantity && productQuantity.onOrder ? productQuantity.onOrder : 0;
}

const getCallToBuyQuantity = (productQuantity: GetQuantityResult) => {
    return productQuantity && productQuantity.callToBuy ? productQuantity.callToBuy : 0;
}

const buildMailTo = (productStockRow: PartnerStockRow, productInventory: ProductInventoryInfo, productQuantity: GetQuantityResult) => {

    const isCanadianPartner = productStockRow.IsCanadian;

    const body = productStockRow.PriceAvailabilityContactName + ',<br/><br/>'
        + '[SPECIFY THE NATURE OF YOUR REQUEST HERE] <br/><br/>'
        + 'PLEASE NOTE:  Data in iNET should be trusted.  You should only be reaching out if this is a Call to Buy situation or there is a specific issue or request you have on this item.  Pricing is updated nightly, and Quantity is pulled in real time.<br/><br/>'
        + 'MFR PN: ' + productInventory.ProductNumber + '<br/>'
        + 'Impact Partner PN: ' + productStockRow.ImpactPartnerPartNumber + '<br/>'
        + 'Description: ' + (productInventory.Remanufactured ? '[REMANUFACTURED] ' : '') + encodeURIComponent(productStockRow.OwnDescription) + '<br/><br/>'
        + 'Quantities: ' + '<br/>'
        + 'On Order: ' + getOnOrderQuantity(productQuantity) + '<br/>'
        + 'Available: ' + getAvailableQuantity(productQuantity) + '<br/>'
        + 'Call to Buy: ' + getCallToBuyQuantity(productQuantity) + '<br/>'
        + 'Cost: ' /*+ (isCanadianPartner ? "CAD " : "") +*/ + formatMoney(productStockRow.PricePerUnit) + '<br/><br/>';

    return 'mailto:' + productStockRow.PriceAvailabilityContactEmail
        + '?subject=' + encodeURIComponent('INET Sharing Request')
        + '&body=' + body.replace(/<br\s*\/?>/mg, "%0D%0A");
}

export { buildMailTo };
